import React from "react";
import WMAD_slider from "./WMAD_slider";
import { useTranslations } from "next-intl";
const WMAD_banner = () => {
  const t = useTranslations("aboutUs.WMAD");
  return (
    <div className=" bg-[#010140] h-[688px]  mt-[90px] relative z-10">
      <div className="mds:pt-[70px]  pt-[40px] pb-[10px]">
        <h1 className="mds:text-[48px] responsive mb-[40px] font-[590] m-auto sm:leading-[56px] text-[28px]  sm:text-[32px] text-[#F6F6F6] text-center h-[50px] md:h-[20px]">
          {t("different")}
          <span className="flex justify-center items-center">
            <hr
              className={` bottomborder  w-[138px] flex justify-center ml-[10px] mt-[10px]`}
            />
          </span>
        </h1>
      </div>
      <WMAD_slider />
    </div>
  );
};

export default WMAD_banner;
